import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { FormControlLabel, Checkbox, TextField } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        paddingBottom: "20px"
    }
}));

const UDFCheckBox = (props) => {
    const { UDF } = props;
    const classes = useStyles();

    const changeCheckBoxValue = (event) => {
        props.changecontrolvalue(event, props.bookingID, UDF.UDFCategoryName, UDF.UDFID);
    }

    const GetUserMemberValue = () => {
        if (props.isMembership) {
            let userV = "";

            if (UDF.Users.filter(x => x.userID == props.usernumber).length > 0) {
                let user = UDF.Users.find(x => x.userID == props.usernumber);

                if (user && user.hasOwnProperty('userUDFValue')) {
                    userV = user.userUDFValue;
                }

                return userV;
            }
        }
        else {
            return UDF.Value;
        }
    }

    return (
        <div className={classes.root}>

            <Checkbox
                name={UDF.UDFID.toString()}
                id={UDF.UDFID.toString()}
                color="primary"
                checked={GetUserMemberValue()}
                onChange={changeCheckBoxValue}
                InputLabelProps={{
                    style: { padding: "0 0 0 15px" },
                }}
                {...props}
            />
        </div>
    );
};

UDFCheckBox.propTypes = {
    UDF: PropTypes.object.isRequired
};

export default UDFCheckBox;
